import { FC } from 'react';
import { BreakdownsResult } from 'api/useAnalytics';
import { PieChart, Pie, LabelList } from 'recharts';

import { Card, CardContent, CardHeader } from 'components/ui/card';
import { ChartContainer, ChartTooltip } from 'components/ui/chart';

import { AnalyticsBoxHeader } from '../AnalyticsBoxHeader/AnalyticsBoxHeader';
import { AnalyticsLoadingBox } from '../AnalyticsLoadingBox';
import { PieChartTooltip } from './PieChartTooltip/PieChartTooltip';
import { usePieChartConfig } from './hooks/use-pie-chart-config';

type AnalyticsPieBoxProps = {
  isLoading: boolean;
  breakdown: BreakdownsResult | undefined;
};

export const AnalyticsPieBox: FC<AnalyticsPieBoxProps> = ({
  isLoading,
  breakdown
}) => {
  const { chartConfig, chartData } = usePieChartConfig(breakdown);

  if (isLoading || !breakdown || !chartConfig) return <AnalyticsLoadingBox />;

  const metricName = breakdown.name;

  return (
    <Card className="p-3">
      <CardHeader>
        <AnalyticsBoxHeader
          metricName={metricName}
          isBreakdown
          shouldHideBreakdown
        />
      </CardHeader>
      <CardContent>
        <ChartContainer
          config={chartConfig}
          className="w-full h-full min-h-[220px]"
        >
          <PieChart>
            <ChartTooltip content={<PieChartTooltip />} />
            <Pie data={chartData} dataKey="value" isAnimationActive={false}>
              <LabelList
                dataKey="breakdownValue"
                stroke="white"
                fontSize={12}
                opacity={1}
                fontWeight={300}
                formatter={(value: keyof typeof chartConfig) =>
                  chartConfig[value]?.label
                }
              />
            </Pie>
          </PieChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
};
